import { getData } from 'src/services/RestApi';
import { setCacheServices, getCacheServices } from 'src/utils/cache-data';

export const servicesApi = {
  async getItems(types = []) {
    let cachedData = getCacheServices();
    if (Array.isArray(cachedData)) {
      return this.filterItems(cachedData, types);
    }

    // Fetch from API if no cached data
    try {
      let { result } = await getData('api/service/list/cache');
      if (result) {
        setCacheServices(result); // Save to cache
        return this.filterItems(result, types);
      }
    } catch (error) {
      console.error('Failed to fetch services:', error);
      return [];
    }
  },

  filterItems(arrays, types) {
    if (!Array.isArray(types) || types.length === 0) {
      return arrays; // Return all if no filter is applied
    }
    return arrays.filter(item => types.includes(item.type));
  }
};
